import config from "../config/app.conf.json";

export default userEmail => {
  return {
    url: `${config.api.users_search_uri}/${userEmail}`,
    method: "GET"
  };
};
